import { ErrorCard as BaseErrorCard } from '@percent/domain/verifications'
import { ErrorCardProps } from './ErrorCard.types'

export const ErrorCard = ({
  title,
  subtitle,
  variant,
  children,
  sendAnalytics = true,
}: ErrorCardProps) => {
  return (
    <BaseErrorCard
      title={title}
      subtitle={subtitle}
      variant={variant}
      children={children}
    />
  )
}
